/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCategoryControllerCreateMutationResponse } from "../../models/incidentAgentController/IncidentCategoryControllerCreate";

function getIncidentCategoryControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/incident-agent/categories` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/categories}
 */
export async function incidentCategoryControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentCategoryControllerCreateMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIncidentCategoryControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}